import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '@/store'
import convoStore from '../convo-store'
import convoUtils from './convo-utils'
import fetchStatements from './fetch-statements'
import { IStatement } from '@/model/statement';
import statementStore from '@/store/statement/statement-store';

export default async function addConvoStatement (context: BareActionContext<ConvoState, RootState>, statement: IStatement ) {
  convoUtils.convoService.addStatement(convoStore.state.convo, statement).then((result: any) => {
    statementStore.dispatchHideStatement(statement)
    fetchStatements(context, convoStore.state.convo)
  })

  return
}
